module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-voxi-01.1bd2e64f.jpg";